<template>
  <el-dialog
    title="修改公告"
    :visible.sync="noticeDetailDialogVisible"
    @close="closeDialog"
  >
    <el-form
      :model="noticeDetail"
      ref="form"
      label-width="140px"
      class="notice-form"
    >
      <!-- <el-form-item
        label="类型："
        prop="type"
        :rules="[
            { required: true, message: '类型不能为空'}
          ]"
      >
        <el-select :value="noticeDetail.type" placeholder="请选择">
          <el-option
            v-for="item in noticeTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="标题：" prop="title">
        <div v-for="lang in languageList" :key="lang.value">
          （{{ lang.label }}标题）
          <el-input
            type="text"
            :value="noticeDetail.title[lang.value]"
            auto-complete="off"
            @input="handleSetNoticeDetail('title', lang.value, $event)"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item prop="content" label="内容：">
        <div
          v-if="noticeDetail.type === 2"
          v-for="lang in languageList"
          :key="lang.value"
        >
          （{{ lang.label }}内容）
          <editor
            :value="noticeDetail.content[lang.value]"
            class="editor"
            @change="handleSetNoticeDetail('content', lang.value, $event)"
          ></editor>
        </div>
        <div
          v-if="noticeDetail.type === 1"
          v-for="lang in languageList"
          :key="lang.value"
        >
          （{{ lang.label }}内容）
          <upload
            :data="{ language: lang.value }"
            :value="noticeDetail.content[lang.value]"
            @change="handleSetNoticeDetail('content', lang.value, $event)"
          ></upload>
        </div>
      </el-form-item>
      <el-form-item prop="url" label="跳转链接：">
        <el-input
          :value="noticeDetail.url"
          @input="handleSetNoticeDetail('url', null, $event)"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave('form')">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Editor from 'components/editor';
import Upload from 'components/upload';
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'UpdateNotice',
  components: {
    Editor,
    Upload
  },
  computed: {
    ...mapState('notice', [
      'languageList',
      'noticeTypes',
      'noticeDetailDialogVisible',
      'noticeDetail'
    ])
  },
  methods: {
    ...mapActions('notice', ['update']),
    ...mapMutations('notice', [
      'setNoticeDetailDialogVisible',
      'setNoticeDetail'
    ]),
    closeDialog() {
      this.setNoticeDetailDialogVisible(false);
    },
    handleSetNoticeDetail(type, key, value) {
      this.setNoticeDetail({
        ...this.noticeDetail,
        [type]:
          type === 'url' ? value : { ...this.noticeDetail[type], [key]: value }
      });
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.update(this.noticeDetail).then(() => {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.setNoticeDetailDialogVisible(false);
            this.$emit('refresh');
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.announcement-form {
  margin-right: 100px;
}
.editor {
  height: 500px;
}
</style>
